/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-23 12:25:50
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-06-22 13:52:07
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorText/tool.ts
 */

import {
  convertSpecificError,
  generateCollapseErrorMsgDisplay,
  generateCollapseOpen,
} from '@/src/constrains/SalesChannelPreviewPageComponents/tools';
import { errCodesMap } from '@/src/error/code';
import { EPreviewSize } from '@/src/types/common/SalesChannel';
import { get } from 'lodash';

export enum TextTheme {
  ClickableText1 = 'clickableText1',
  ClickableText2 = 'clickableText2',
  ClickableText3 = 'clickableText3',
  Heading1 = 'heading1',
  Heading2 = 'heading2',
  Heading3 = 'heading3',
  Heading4 = 'heading4',
  Heading5 = 'heading5',
  Heading6 = 'heading6',
  Heading7 = 'heading7',
  Heading8 = 'heading8',
  Heading9 = 'heading9',
  Price1 = 'price1',
  Price2 = 'price2',
  Price3 = 'price3',
  SubTitle1 = 'subtitle1',
  SubTitle2 = 'subtitle2',
  Body1 = 'body1',
  Body2 = 'body2',
  Body3 = 'body3',
}

export const fontList = [
  { value: 'Open Sans', label: 'Open Sans' },
  { value: 'Garamond', label: 'Garamond' },
  {
    value: 'Merriweather',
    label: 'Merriweather',
  },
  {
    value: 'Roboto Slab',
    label: 'Roboto Slab',
  },
  {
    value: 'Playfair Display',
    label: 'Playfair Display',
  },
  {
    value: 'Lora',
    label: 'Lora',
  },
  {
    value: 'PT Serif',
    label: 'PT Serif',
  },
  {
    value: 'Roboto',
    label: 'Roboto',
  },
  {
    value: 'Noto Sans JP',
    label: 'Noto Sans JP',
  },
  {
    value: 'Lato',
    label: 'Lato',
  },
  {
    value: 'Montserrat',
    label: 'Montserrat',
  },
  {
    value: 'Roboto Mono',
    label: 'Roboto Mono',
  },
  {
    value: 'Inconsolata',
    label: 'Inconsolata',
  },
  {
    value: 'Source Code Pro',
    label: 'Source Code Pro',
  },
  {
    value: 'PT Mono',
    label: 'PT Mono',
  },
  {
    value: 'IBM Plex Mono',
    label: 'IBM Plex Mono',
  },
  {
    value: 'zt_neue_ralewe',
    label: 'zt_neue_ralewe',
  },
];

export const genericFamilyOption = [
  {
    value: 'serif',
    label: 'Serif',
  },
  {
    value: 'sans-serif',
    label: 'Sans serif',
  },
  {
    value: 'system-ui',
    label: 'System ui',
  },
];

export const title = (title: TextTheme) => {
  switch (title) {
    case TextTheme.ClickableText1:
      return 'Clickable Text 1';
    case TextTheme.ClickableText2:
      return 'Clickable Text 2';
    case TextTheme.ClickableText3:
      return 'Clickable Text 3';
    case TextTheme.Heading1:
      return 'Heading 1';
    case TextTheme.Heading2:
      return 'Heading 2';
    case TextTheme.Heading3:
      return 'Heading 3';
    case TextTheme.Heading4:
      return 'Heading 4';
    case TextTheme.Heading5:
      return 'Heading 5';
    case TextTheme.Heading6:
      return 'Heading 6';
    case TextTheme.Heading7:
      return 'Heading 7';
    case TextTheme.Heading8:
      return 'Heading 8';
    case TextTheme.Heading9:
      return 'Heading 9';
    case TextTheme.Price1:
      return 'Price 1';
    case TextTheme.Price2:
      return 'Price 2';
    case TextTheme.Price3:
      return 'Price 3';
    case TextTheme.SubTitle1:
      return 'Subtitle 1';
    case TextTheme.SubTitle2:
      return 'Subtitle 2';
    case TextTheme.Body1:
      return 'Body 1';
    case TextTheme.Body2:
      return 'Body 2';
    case TextTheme.Body3:
      return 'Body 3';
  }
};

export const fixedCollapse = [
  TextTheme.ClickableText1,
  TextTheme.ClickableText2,
  TextTheme.ClickableText3,
  TextTheme.Heading1,
  TextTheme.Heading2,
  TextTheme.Heading3,
  TextTheme.Heading4,
  TextTheme.Heading5,
  TextTheme.Heading6,
  TextTheme.Heading7,
  TextTheme.Heading8,
  TextTheme.Heading9,
  TextTheme.Price1,
  TextTheme.Price2,
  TextTheme.Price3,
  TextTheme.SubTitle1,
  TextTheme.SubTitle2,
  TextTheme.Body1,
  TextTheme.Body2,
  TextTheme.Body3,
];

export const defaultTextListBySize = (size: EPreviewSize) => {
  switch (size) {
    case EPreviewSize.WIDE: {
      return fixedCollapse;
    }
    case EPreviewSize.TABLET: {
      // return [
      //   TextTheme.ClickableText1,
      //   TextTheme.ClickableText2,
      //   TextTheme.ClickableText3,
      //   TextTheme.Heading1,
      //   TextTheme.Heading2,
      //   TextTheme.Heading3,
      //   TextTheme.Heading4,
      //   TextTheme.Heading6,
      //   TextTheme.Heading8,
      //   TextTheme.Price1,
      //   TextTheme.Price2,
      //   TextTheme.SubTitle1,
      //   TextTheme.SubTitle2,
      //   TextTheme.Body1,
      // ];
      return fixedCollapse;
    }
    case EPreviewSize.MOBILE: {
      // return [
      //   TextTheme.ClickableText2,
      //   TextTheme.ClickableText3,
      //   TextTheme.Heading1,
      //   TextTheme.Heading2,
      //   TextTheme.Heading3,
      //   TextTheme.Heading4,
      //   TextTheme.Heading6,
      //   TextTheme.Heading8,
      //   TextTheme.Price1,
      //   TextTheme.Price2,
      //   TextTheme.SubTitle1,
      //   TextTheme.Body1,
      // ];
      return fixedCollapse;
    }
    default: {
      return fixedCollapse;
    }
  }
};

export const getThemesBySize = (size: EPreviewSize) => {
  switch (size) {
    case EPreviewSize.WIDE: {
      return {
        clickableText1: {
          textFont: 'Open Sans',
          fontSize: 16,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 22,
        },
        clickableText2: {
          textFont: 'Open Sans',
          fontSize: 14,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 20,
        },
        clickableText3: {
          textFont: 'Open Sans',
          fontSize: 12,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 18,
        },
        heading1: {
          textFont: 'Open Sans',
          fontSize: 64,
          bold: false,
          italic: true,
          underline: false,
          textColor: '#000',
          lineHeight: 64,
        },
        heading2: {
          textFont: 'Open Sans',
          fontSize: 40,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 56,
        },
        heading3: {
          textFont: 'Open Sans',
          fontSize: 32,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 48,
        },
        heading4: {
          textFont: 'Open Sans',
          fontSize: 24,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 32,
        },
        heading5: {
          textFont: 'Open Sans',
          fontSize: 22,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 30,
        },
        heading6: {
          textFont: 'Open Sans',
          fontSize: 20,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 28,
        },
        heading7: {
          textFont: 'Open Sans',
          fontSize: 18,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 24,
        },
        heading8: {
          textFont: 'Open Sans',
          fontSize: 16,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 24,
        },
        heading9: {
          textFont: 'Open Sans',
          fontSize: 24,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 32,
        },
        price1: {
          textFont: 'Open Sans',
          fontSize: 24,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#D20000',
          lineHeight: 32,
        },
        price2: {
          textFont: 'Open Sans',
          fontSize: 16,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#D20000',
          lineHeight: 24,
        },
        price3: {
          textFont: 'Open Sans',
          fontSize: 20,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#D20000',
          lineHeight: 28,
        },
        subtitle1: {
          textFont: 'Open Sans',
          fontSize: 16,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 24,
        },
        subtitle2: {
          textFont: 'Open Sans',
          fontSize: 14,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 20,
        },
        body1: {
          textFont: 'Open Sans',
          fontSize: 13,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 20,
        },
        body2: {
          textFont: 'Open Sans',
          fontSize: 12,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 20,
        },
        body3: {
          textFont: 'Open Sans',
          fontSize: 11,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 16,
        },
      };
    }
    case EPreviewSize.TABLET: {
      return {
        clickableText1: {
          textFont: 'Open Sans',
          fontSize: 14,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 20,
        },
        clickableText2: {
          textFont: 'Open Sans',
          fontSize: 12,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 18,
        },
        clickableText3: {
          textFont: 'Open Sans',
          fontSize: 12,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 18,
        },
        heading1: {
          textFont: 'Open Sans',
          fontSize: 40,
          bold: false,
          italic: true,
          underline: false,
          textColor: '#000',
          lineHeight: 40,
        },
        heading2: {
          textFont: 'Open Sans',
          fontSize: 24,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 36,
        },
        heading3: {
          textFont: 'Open Sans',
          fontSize: 20,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 28,
        },
        heading4: {
          textFont: 'Open Sans',
          fontSize: 17,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 24,
        },
        heading5: {
          textFont: 'Open Sans',
          fontSize: 16,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 24,
        },
        heading6: {
          textFont: 'Open Sans',
          fontSize: 16,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 24,
        },
        heading7: {
          textFont: 'Open Sans',
          fontSize: 14,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 20,
        },
        heading8: {
          textFont: 'Open Sans',
          fontSize: 14,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 20,
        },
        heading9: {
          textFont: 'Open Sans',
          fontSize: 17,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 24,
        },
        price1: {
          textFont: 'Open Sans',
          fontSize: 16,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#D20000',
          lineHeight: 24,
        },
        price2: {
          textFont: 'Open Sans',
          fontSize: 14,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#D20000',
          lineHeight: 20,
        },
        price3: {
          textFont: 'Open Sans',
          fontSize: 16,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#D20000',
          lineHeight: 24,
        },
        subtitle1: {
          textFont: 'Open Sans',
          fontSize: 14,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 20,
        },
        subtitle2: {
          textFont: 'Open Sans',
          fontSize: 12,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 20,
        },
        body1: {
          textFont: 'Open Sans',
          fontSize: 12,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 20,
        },
        body2: {
          textFont: 'Open Sans',
          fontSize: 12,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 20,
        },
        body3: {
          textFont: 'Open Sans',
          fontSize: 10,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 16,
        },
      };
    }
    case EPreviewSize.MOBILE: {
      return {
        clickableText1: {
          textFont: 'Open Sans',
          fontSize: 12,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 18,
        },
        clickableText2: {
          textFont: 'Open Sans',
          fontSize: 11,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 18,
        },
        clickableText3: {
          textFont: 'Open Sans',
          fontSize: 11,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 18,
        },
        heading1: {
          textFont: 'Open Sans',
          fontSize: 40,
          bold: false,
          italic: true,
          underline: false,
          textColor: '#000',
          lineHeight: 40,
        },
        heading2: {
          textFont: 'Open Sans',
          fontSize: 20,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 28,
        },
        heading3: {
          textFont: 'Open Sans',
          fontSize: 20,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 28,
        },
        heading4: {
          textFont: 'Open Sans',
          fontSize: 14,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 20,
        },
        heading5: {
          textFont: 'Open Sans',
          fontSize: 14,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 20,
        },
        heading6: {
          textFont: 'Open Sans',
          fontSize: 12,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 18,
        },
        heading7: {
          textFont: 'Open Sans',
          fontSize: 12,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 18,
        },
        heading8: {
          textFont: 'Open Sans',
          fontSize: 12,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 18,
        },
        heading9: {
          textFont: 'Open Sans',
          fontSize: 12,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 18,
        },
        price1: {
          textFont: 'Open Sans',
          fontSize: 16,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#D20000',
          lineHeight: 24,
        },
        price2: {
          textFont: 'Open Sans',
          fontSize: 12,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#D20000',
          lineHeight: 18,
        },
        price3: {
          textFont: 'Open Sans',
          fontSize: 12,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#D20000',
          lineHeight: 18,
        },
        subtitle1: {
          textFont: 'Open Sans',
          fontSize: 12,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 18,
        },
        subtitle2: {
          textFont: 'Open Sans',
          fontSize: 10,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 14,
        },
        body1: {
          textFont: 'Open Sans',
          fontSize: 12,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 18,
        },
        body2: {
          textFont: 'Open Sans',
          fontSize: 12,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 18,
        },
        body3: {
          textFont: 'Open Sans',
          fontSize: 10,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 16,
        },
      };
    }
    default: {
      return {
        clickableText1: {
          textFont: 'Open Sans',
          fontSize: 16,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 22,
        },
        clickableText2: {
          textFont: 'Open Sans',
          fontSize: 14,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 21,
        },
        clickableText3: {
          textFont: 'Open Sans',
          fontSize: 12,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 18,
        },
        heading1: {
          textFont: 'Open Sans',
          fontSize: 64,
          bold: false,
          italic: true,
          underline: false,
          textColor: '#000',
          lineHeight: 64,
        },
        heading2: {
          textFont: 'Open Sans',
          fontSize: 40,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 55,
        },
        heading3: {
          textFont: 'Open Sans',
          fontSize: 32,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 48,
        },
        heading4: {
          textFont: 'Open Sans',
          fontSize: 24,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 33,
        },
        heading5: {
          textFont: 'Open Sans',
          fontSize: 22,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 33,
        },
        heading6: {
          textFont: 'Open Sans',
          fontSize: 20,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 28,
        },
        heading7: {
          textFont: 'Open Sans',
          fontSize: 18,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 24,
        },
        heading8: {
          textFont: 'Open Sans',
          fontSize: 16,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 22,
        },
        heading9: {
          textFont: 'Open Sans',
          fontSize: 17,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 24,
        },
        price1: {
          textFont: 'Open Sans',
          fontSize: 20,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#D20000',
          lineHeight: 28,
        },
        price2: {
          textFont: 'Open Sans',
          fontSize: 16,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#D20000',
          lineHeight: 22,
        },
        price3: {
          textFont: 'Open Sans',
          fontSize: 20,
          bold: true,
          italic: false,
          underline: false,
          textColor: '#D20000',
          lineHeight: 28,
        },
        subtitle1: {
          textFont: 'Open Sans',
          fontSize: 16,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 24,
        },
        subtitle2: {
          textFont: 'Open Sans',
          fontSize: 14,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 21,
        },
        body1: {
          textFont: 'Open Sans',
          fontSize: 13,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 20,
        },
        body2: {
          textFont: 'Open Sans',
          fontSize: 12,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 20,
        },
        body3: {
          textFont: 'Open Sans',
          fontSize: 12,
          bold: false,
          italic: false,
          underline: false,
          textColor: '#000',
          lineHeight: 20,
        },
      };
    }
  }
};

export const textThemeValidation = (x) => {
  const specificErr = {
    fontSize: [],
  };
  if (!x?.fontSize) {
    specificErr.fontSize.push(errCodesMap[999978]);
  }
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError: [],
  };
};

export const convertDataFromServerToRedux = (res: any, size: EPreviewSize) => {
  const {
    uuid,
    hasError,
    contentUuid,
    salesChannelContent,
    salesChannelName,
    modifiedDate,
    createdDate,
    theme,
  } = res;
  const _isNew = !uuid;
  const collapseOpen = generateCollapseOpen([...defaultTextListBySize(size)]);
  const collapseErrorMsgDisplay = generateCollapseErrorMsgDisplay(
    [...defaultTextListBySize(size)],
    !_isNew,
  );
  const themeObj = {};
  const defaultTheme = getThemesBySize(size);

  fixedCollapse.map((v) => {
    Object.assign(themeObj, { [v]: get(theme, v) || get(defaultTheme, v) });
  });
  return {
    uuid,
    hasError,
    collapseErrorMsgDisplay,
    collapseOpen,
    contentUuid,
    salesChannelContent: salesChannelContent || {},
    salesChannelName,
    modifiedDate,
    createdDate,
    theme: themeObj,
  };
};

export const convertDataFromReduxToServer = (state: any) => {
  const {
    uuid,
    hasError,
    contentUuid,
    salesChannelContent,
    salesChannelName,
    modifiedDate,
    createdDate,
    theme,
  } = state;
  return {
    uuid,
    hasError,
    contentUuid,
    salesChannelContent,
    salesChannelName,
    modifiedDate,
    createdDate,
    theme,
  };
};
